<template>
  <div class="header" style="color: #FFFFFF;">
    <div class="header_content">
      <div class="logo">
        <div class="logoPic" @click="goHome">
          <img src="../../../../static/img/logo.png" alt="" srcset="">
        </div>
      </div>
      <div class="flex-between"
           style="color: #FFFFFF;font-size: 17px;margin-left: 50px;align-items: end;">
        <div>
          <img v-if="getIndex==1" src="../../../../static/img/tag.png" alt=""
               style="width: 15px;height: 15px;margin: auto">
          <div :class="getIndex==1?'t_1_a':'t_1'" style="margin: 0 15px 0 15px;cursor: pointer" @click="getUrl(1)">
            首页
          </div>
        </div>
        <div>
          <img v-if="getIndex==2" src="../../../../static/img/tag.png" alt=""
               style="width: 15px;height: 15px;margin: auto">
          <div :class="getIndex==2?'t_1_a':'t_1'" style="margin: 0 15px 0 15px;cursor: pointer" @click="getUrl(2)">
            关于我们
          </div>
        </div>
        <div>
          <img v-if="getIndex==3" src="../../../../static/img/tag.png" alt=""
               style="width: 15px;height: 15px;margin: auto">
          <div :class="getIndex==3?'t_1_a':'t_1'" style="margin: 0 15px 0 15px;cursor: pointer" @click="getUrl(3)">
            产品中心
          </div>
        </div>
        <div>
          <img v-if="getIndex==4" src="../../../../static/img/tag.png" alt=""
               style="width: 15px;height: 15px;margin: auto">
          <div :class="getIndex==4?'t_1_a':'t_1'" style="margin: 0 15px 0 15px;cursor: pointer" @click="getUrl(4)">
            工程案例
          </div>
        </div>
        <div>
          <img v-if="getIndex==5" src="../../../../static/img/tag.png" alt=""
               style="width: 15px;height: 15px;margin: auto">
          <div :class="getIndex==5?'t_1_a':'t_1'" style="margin: 0 15px 0 15px;cursor: pointer" @click="getUrl(5)">
            资料下载
          </div>
        </div>
        <div>
          <img v-if="getIndex==6" src="../../../../static/img/tag.png" alt=""
               style="width: 15px;height: 15px;margin: auto">
          <div :class="getIndex==6?'t_1_a':'t_1'" style="margin: 0 15px 0 15px;cursor: pointer" @click="getUrl(6)">
            联系我们
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        inject: ['reload'],
        props: {
            'getIndex': {
                type: Number,
                default: 1,
            }
        },
        data() {
            return {
                //getIndex: 1,
                isLogin: true,
                isBottom: false,
                dialogVisible: false,
                user: window.localStorage.getItem('truename'),
                currentId: '1',
            }
        },
        mounted() {
            //this.getIndex = this.tab;
        },
        computed: {
            // token: function () {
            //     var isLogin;
            //     if (window.localStorage.getItem('accessToken')) {
            //         isLogin = true;
            //     } else {
            //         isLogin = false;
            //     }
            //     console.log(isLogin)
            //     return isLogin;
            // },
        },
        components: {},
        created() {
        },
        methods: {
            getUrl(index) {
                this.getIndex = index;
                if (index == 1) {
                    this.$router.replace("/")
                }
                if (index == 2) {
                    this.$router.replace("/about")
                }
                if (index == 3) {
                    this.$router.replace("/product")
                }
                if (index == 4) {
                    this.$router.replace("/case")
                }
                if (index == 5) {
                    this.$router.replace("/download")
                }
                if (index == 6) {
                    this.$router.replace("/contact")
                }
            },
            goHome() {
                this.getIndex = 1;
                this.$router.replace('/')
            }
        }
    }
</script>

<style scoped>
  .t_1 {
    font-family: HarmonyOS Sans SC;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 5px;
  }

  .t_1_a {
    font-family: HarmonyOS Sans SC;
    font-weight: 500;
    font-size: 16px;
    color: #31E3FD;
    margin-top: 5px;
  }

  .header_content {
    width: 80%;
    margin: auto;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }

  .header {
    height: 70px;
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 13;
    background: #121212;
  }

  .logo {
    width: 65px;
    display: flex;
    align-items: center;
    font-size: 23px;
    color: #121C33;
    cursor: pointer;
  }

  .logoPic {
    width: 190px;
    height: 40px;
  }

  .logoPic img {
    width: 190px;
    height: 40px;
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navber.vue